export const createLanguageQueryString = (languageId?: string, appending = false): string => {
  return languageId ? `${appending ? '&' : '?'}languageId=${languageId}` : ''
}
